import {createAction} from "@reduxjs/toolkit";

const setIsThemeInstalling = createAction('IS_THEME_INSTALLING');
const setIsSynchronizing = createAction('IS_SYNCHRONIZING');
const setAppEnabled = createAction('APP_ENABLED');

export {setIsThemeInstalling, setIsSynchronizing, setAppEnabled}